import * as S from './Input.styled';

export default S.Input;
